import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { WatchdogMaterialModule } from 'src/app/material-module';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  styleUrl: './login.component.css',
  templateUrl: './login.component.html',
  imports: [CommonModule,
    WatchdogMaterialModule,
    FormsModule,
    ReactiveFormsModule],
    standalone: true,
})
export class LoginComponent {
  form: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });
  constructor(private router: Router, private auth: AuthService) {}

  error: string | null = null;

  submit() {
    const { username, password } = this.form.value;
    if (this.auth.login(username, password)) {
      this.error = null;
      this.router.navigate(['/admin/dashboard']);
    } else {
      this.error = 'Invalid credentials. Use the demo login shown below.';
    }
  }

}
